import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  initState,
  sendForm
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import connect from 'react-redux/es/connect/connect';
import TaskFrom from './../../../../../components/Tasks/TaskFrom';

class TaskCreate extends Component {
  componentDidMount() {
    this.props.initState();
    window.scrollTo(0, 0);
  }

  render() {
    const hasNewTask = true;
    return (
      <React.Fragment>
        <TaskFrom
          reducerName={this.props.reducerName}
          sendForm={() => this.props.sendForm()}
          hasNewTask={hasNewTask}
        />
      </React.Fragment>
    );
  }
}

TaskCreate.propTypes = {
  reducerName: PropTypes.string.isRequired,
  initState: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.reducerName)),
  sendForm: () => dispatch(sendForm(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskCreate);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskCreate/TaskCreate.js